import clsx from "clsx";
import BodyText from "@ancon/wildcat-ui/web/orderweb/BodyText";

import styles from "./CheckoutOutOfStockFormItem.module.scss";
import Selectable, { SelectableType } from "../support/Selectable";
import QuantityModifier from "../support/QuantityModifier";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default function CheckoutOutOfStockFormItem() {
  return (
    <Container>
      <div className={clsx(styles.row, styles.spaceBetween, styles.titleRow)}>
        <div className={clsx(styles.row, styles.spaceBetween)}>
          <div>
            <BodyText className={styles.productName}>Product Name</BodyText>
            <BodyText color="body-2">200 kr</BodyText>
          </div>
          <div>
            <BodyText
              color="body-2"
              className={styles.singleLineText}
            >{`x 3`}</BodyText>
          </div>
        </div>
        <div>
          <div className={styles.outOfStockTag}>
            <BodyText fontSize="1.2rem" className={styles.singleLineText}>
              Only 2 Available
            </BodyText>
          </div>
        </div>
      </div>

      <div>
        <BodyText className={styles.warningText}>This will be removed</BodyText>
        <div>
          <div className={clsx(styles.row, styles.optionRow)}>
            <Selectable
              type={SelectableType.RadioButton}
              checked
              containerClassName={styles.radioButton}
            />
            <BodyText>Add 2 items (Available Quantity)</BodyText>
          </div>

          <div
            className={clsx(styles.row, styles.optionRow, styles.spaceBetween)}
          >
            <div className={styles.row}>
              <Selectable
                type={SelectableType.RadioButton}
                checked
                containerClassName={styles.radioButton}
              />
              <BodyText>Reduce Quantity</BodyText>
            </div>

            <QuantityModifier value={1} max={10} min={1} />
          </div>

          <div className={clsx(styles.row, styles.optionRow)}>
            <Selectable
              type={SelectableType.RadioButton}
              checked
              containerClassName={styles.radioButton}
            />
            <BodyText>Remove item</BodyText>
          </div>
        </div>
      </div>
    </Container>
  );
}
